import apiService from "@/core/services/apiService";

export type State = { classes: object };
import {Module, VuexModule, Mutation, Action} from "vuex-module-decorators";
import {Actions, Mutations} from "@/store/enums/store.enums";
import {ShopOrdersActions, ShopOrdersMutation} from "@/modules/shop-orders/store/enums";

@Module
export default class Store extends VuexModule {
    renderKey = 1;
    listParams = {
        page: 1,
        results: 10,
        search: null,
        sort: [],
        filter: {}
    };
    listCache = [];
    listTotal = 0;
    states = [];
    storages = [];
    emailTemplates = [];
    countries = [];
    shippingDashboardCache = [];
    shippingDashboardTotal = 0;
    abandonedBasketsCache = [];
    abandonedBasketsTotal = 0;

    get getShopOrdersRenderKey() {
        return 'shop-orders-' + this.renderKey;
    }

    get getShopOrdersLastListResult() {
        return this.listCache;
    }

    get getShopOrdersLastListTotal() {
        return this.listTotal;
    }

    get getShopOrdersStates() {
        return this.states;
    }

    get getShopOrdersStorages() {
        return this.storages;
    }

    get getShopOrdersEmailTemplates() {
        return this.emailTemplates;
    }

    get getShopOrdersCountries() {
        return this.countries;
    }

    get getShopOrdersShippingDashboard() {
        return this.shippingDashboardCache;
    }

    get getShopOrdersShippingDashboardTotal() {
        return this.shippingDashboardTotal;
    }

    get getShopOrdersAbandonedBaskets() {
        return this.abandonedBasketsCache;
    }

    get getShopOrdersAbandonedBasketsTotal() {
        return this.abandonedBasketsTotal;
    }

    @Mutation
    [ShopOrdersMutation.SET_SHIPPING_DASHBOARD]({ listTotal, listCache }) {
        this.shippingDashboardTotal = listTotal;
        this.shippingDashboardCache = listCache;
    }

    @Mutation
    [ShopOrdersMutation.SET_ABANDONED_BASKETS]({ listTotal, listCache }) {
        this.abandonedBasketsTotal = listTotal;
        this.abandonedBasketsCache = listCache;
    }

    @Mutation
    [ShopOrdersMutation.SET_RENDER_UPDATE]() {
        this.renderKey++;
    }

    @Mutation
    [ShopOrdersMutation.SET_LIST_RESULT]({listParams, listTotal, listCache}) {
        this.listParams = listParams;
        this.listCache = listCache;
        this.listTotal = listTotal;
    }

    @Mutation
    [ShopOrdersMutation.SET_STATES](data) {
        this.states = data;
    }

    @Mutation
    [ShopOrdersMutation.SET_STORAGES](data) {
        this.storages = data;
    }

    @Mutation
    [ShopOrdersMutation.SET_EMAIL_TEMPLATES](data) {
        this.emailTemplates = data;
    }

    @Mutation
    [ShopOrdersMutation.SET_COUNTRIES](data) {
        this.countries = data;
    }

    @Action
    [ShopOrdersActions.REFRESH_LIST]() {
        this.context.dispatch(ShopOrdersActions.FETCH_LIST, this.listParams);
    }

    @Action
    [ShopOrdersActions.FETCH_LIST](params) {

        return new Promise<void>((resolve, reject) => {

            apiService.post("order/list", params).then((response) => {

                const data = response.data || null;

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(ShopOrdersMutation.SET_LIST_RESULT, {
                    listParams: params,
                    listTotal: data.results,
                    listCache: data.result
                });
                resolve();

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ShopOrdersActions.GET_ITEM](detailId) {

        return new Promise<void>((resolve, reject) => {

            apiService.get(`order/get/${detailId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ShopOrdersActions.UPDATE_STATE](payload) {

        return new Promise((resolve, reject) => {

            const {id, data} = payload;

            apiService.put(`order/update-state/${id}`, data).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(ShopOrdersMutation.SET_RENDER_UPDATE);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ShopOrdersActions.UPDATE_COMMENT](payload) {

        return new Promise((resolve, reject) => {

            const {id, data} = payload;

            apiService.put(`order/update-comment/${id}`, data).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ShopOrdersActions.FETCH_STATES]() {

        return new Promise<void>((resolve, reject) => {

            apiService.get("order/states").then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(ShopOrdersMutation.SET_STATES, data.result);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ShopOrdersActions.FETCH_STORAGES]() {

        return new Promise<void>((resolve, reject) => {

            apiService.get("order/storages").then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(ShopOrdersMutation.SET_STORAGES, data.result);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ShopOrdersActions.CREATE_CREDIT](payload) {

        return new Promise((resolve, reject) => {

            const {id, data} = payload;

            apiService.post(`order/create-credit/${id}`, data).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ShopOrdersActions.UPDATE_CREDIT](payload) {

        return new Promise((resolve, reject) => {

            const {id, data} = payload;

            apiService.put(`order/update-credit/${id}`, data).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ShopOrdersActions.DELETE_CREDIT](payload) {

        return new Promise((resolve, reject) => {

            const {id} = payload;

            apiService.delete(`order/delete-credit/${id}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ShopOrdersActions.SEND_EMAIL](payload) {

        return new Promise((resolve, reject) => {

            const {id, data} = payload;

            apiService.post(`order/send-email/${id}`, data).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(ShopOrdersMutation.SET_RENDER_UPDATE);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ShopOrdersActions.CREATE_LABEL](payload) {

        return new Promise((resolve, reject) => {

            const {id} = payload;

            apiService.post(`order/create-label/${id}`, {}).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ShopOrdersActions.CREATE_AMAZON_LABEL](payload) {

        return new Promise((resolve, reject) => {

            const {id} = payload;

            apiService.post(`order/create-amazon-label/${id}`, {}).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ShopOrdersActions.FETCH_EMAIL_TEMPLATES]() {

        return new Promise<void>((resolve, reject) => {

            apiService.get("order/email-templates").then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(ShopOrdersMutation.SET_EMAIL_TEMPLATES, data.result);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ShopOrdersActions.SET_PAYMENT_REMINDER](payload) {

        return new Promise((resolve, reject) => {

            const {id, data} = payload;

            apiService.post(`order/payment-reminder/${id}`, data).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ShopOrdersActions.EXPORT](payload) {

        return new Promise((resolve, reject) => {

            apiService.post("order/export", payload).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ShopOrdersActions.UPDATE_DELIVERY_ADDRESS](payload) {

        return new Promise((resolve, reject) => {

            const {id, data} = payload;

            apiService.put(`order/update-delivery-address/${id}`, data).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ShopOrdersActions.SET_PAID](payload) {

        return new Promise((resolve, reject) => {

            const {id} = payload;

            apiService.put(`order/set-paid/${id}`, {}).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ShopOrdersActions.FETCH_COUNTRIES]() {

        return new Promise<void>((resolve, reject) => {

            apiService.get("order/countries").then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(ShopOrdersMutation.SET_COUNTRIES, data.result);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    // ═══════════════════════════════════════════
    // Phase 4
    // ═══════════════════════════════════════════

    @Action
    [ShopOrdersActions.QUICK_SEARCH](query) {

        return new Promise((resolve, reject) => {

            apiService.post("order/quick-search", { query } as any).then((response) => {

                const data = response.data || null;
                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result || []);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ShopOrdersActions.FETCH_SHIPPING_DASHBOARD](params) {

        return new Promise<void>((resolve, reject) => {

            apiService.post("order/shipping-dashboard", params).then((response) => {

                const data = response.data || null;
                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(ShopOrdersMutation.SET_SHIPPING_DASHBOARD, {
                    listTotal: data.results || 0,
                    listCache: data.result || []
                });
                resolve();

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ShopOrdersActions.FETCH_ABANDONED_BASKETS](params) {

        return new Promise<void>((resolve, reject) => {

            apiService.post("order/abandoned-baskets", params).then((response) => {

                const data = response.data || null;
                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(ShopOrdersMutation.SET_ABANDONED_BASKETS, {
                    listTotal: data.results || 0,
                    listCache: data.result || []
                });
                resolve();

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ShopOrdersActions.FETCH_PRINT_DOCUMENTS](orderId) {

        return new Promise((resolve, reject) => {

            apiService.get("order/print-documents/" + orderId).then((response) => {

                const data = response.data || null;
                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result || []);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ShopOrdersActions.FETCH_PRINT_DOCUMENT]({type, orderId}) {

        return new Promise((resolve, reject) => {

            apiService.get("order/print-document/" + type + "/" + orderId).then((response) => {

                const data = response.data || null;
                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result || null);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

}
